module.exports = __webpack_public_path__ + "static/media/repair-rebels-erhält-den-deutschen-nachhaltigkeitspreis.4a4f9ac5.png";